// Copyright ©️ 2026 eVolve MEP, LLC

import { Box } from '@mantine/core';

import { EvolveLogoLink } from 'app/Layout/HeaderBar/components/EvolveLogoLink';
import { SubNavBackButton } from 'app/Layout/NavBar/NavBarContent/SubNavBackButton';

import classes from './SubNav.module.css';

type Props = {
  navbarExpanded: boolean;
  /** Whether the nav shows the sub nav, in which case the back button replaces the logo. */
  pushed: boolean;
  onBack: () => void;
};

export const NavBarBrand = ({ navbarExpanded, pushed, onBack }: Props) => (
  <Box className={classes.brand} mod={{ pushed }}>
    <Box className={classes.logo} inert={pushed}>
      <EvolveLogoLink disabled={!navbarExpanded} />
    </Box>
    <SubNavBackButton className={classes.back} inert={!pushed || !navbarExpanded} onClick={onBack} />
  </Box>
);
